export default "__VITE_ASSET__B0SjG76H__"